import {Instance} from "../store/slices/instancesSlice";

export const normalizeInstance = (rawInstance: any): Instance => {
    return {
        id: rawInstance.id || '',
        name: rawInstance.name || '',
        status: rawInstance.status || '',
        flavor_id: typeof rawInstance.flavor === 'object'
            ? rawInstance.flavor.id || ''
            : typeof rawInstance.flavor === 'string'
                ? rawInstance.flavor
                : '',
        image_id: (typeof rawInstance.image === 'object'
            ? rawInstance.image.id || ''
            : typeof rawInstance.image === 'string'
                ? rawInstance.image
                : '') || rawInstance.metadata?.image || '',
        created: rawInstance.created || '',
        updated: rawInstance.updated || '',
        state: rawInstance['OS-EXT-STS:vm_state'] || 'N/A',
        task: rawInstance['OS-EXT-STS:task_state'] || rawInstance.task || rawInstance.metadata?.redu_provisioning_phase || 'N/A',
        metadata: rawInstance.metadata || {},
        addresses: rawInstance.addresses || {},
        user_id: rawInstance.user_id || '',
        project_id: rawInstance.tenant_id || '',
        key_name: rawInstance.key_name || null,
        provisioning_mode: rawInstance.provisioning_mode,
        free_resource_kind: rawInstance.free_resource_kind,
        traffic_paused: rawInstance.traffic_paused,
    };
};
